<template>
  <div>
    <!-- 图表容器 -->
    <div ref="chartContainer" style="width: 100%; height: 900px;"></div>
    <!-- 分页按钮 -->
    <div style="text-align: center; margin-top: 20px;">
      <button @click="prevPage" :disabled="currentPage === 0">上一页</button>
      <span style="margin: 0 20px;">第 {{ currentPage + 1 }} 页</span>
      <button @click="nextPage" :disabled="currentPage === totalPages - 1">下一页</button>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: "dataChart",
  data() {
    return {
      chartData: [],
      currentPage: 0, // 当前页码
      totalPages: 2   // 总页数（0-11 为第 0 页，12-23 为第 1 页）
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios.post("/tf3/data/findChart", { gameName: '公婆来找茬' }).then(successResponse => {
        this.chartData = successResponse.data.data;
        this.renderChart(); // 初始渲染图表
      });
    },

    renderChart() {
      const chartDom = this.$refs.chartContainer;
      const myChart = echarts.init(chartDom);

      const data = this.chartData;

      // 分页过滤数据
      const filteredData = this.filterDataByPage(data, this.currentPage);

      // 提取唯一值
      const uniqueCostTimes = [...new Set(filteredData.map(item => item.costTime))];
      const uniqueStatHours = [...new Set(filteredData.map(item => item.statHour))];

      // 构建 matrix 维度数据
      const _matrixDimensionData = {
        x: uniqueCostTimes,
        y: uniqueStatHours.map(hour => ({ value: hour }))
      };

      const option = {
        matrix: {
          x: {
            data: _matrixDimensionData.x,
            levelSize: 40,
            label: { fontSize: 16, color: '#555' }
          },
          y: {
            data: _matrixDimensionData.y,
            levelSize: 70,
            label: { fontSize: 14, color: '#777' }
          },
          corner: {
            data: [{ coord: [-1, -1], value: '消耗时间' }],
            label: { fontSize: 16, color: '#777' }
          },
          body: { data: [] },
          top: 30,
          bottom: 80,
          width: '90%',
          left: 'center'
        },
        tooltip: { trigger: 'axis' },
        dataZoom: [
          { type: 'slider', xAxisIndex: 'all', left: '10%', right: '10%', bottom: 30, height: 30, throttle: 120 },
          { type: 'inside', xAxisIndex: 'all', throttle: 120 }
        ],
        grid: [],
        xAxis: [],
        yAxis: [],
        series: []
      };

      function makeId(xidx, yidx) {
        return `${xidx}|${yidx}`;
      }

      function eachMatrixCell(cb) {
        _matrixDimensionData.y.forEach((yvalItem, yidx) => {
          const yval = yvalItem.value;
          _matrixDimensionData.x.forEach((xval, xidx) => {
            cb(xval, yval, xidx, yidx);
          });
        });
      }

      function generateSeriesData(data, xidx, yidx) {
        const cellData = [];
        data.forEach(item => {
          if (
              _matrixDimensionData.x[xidx] === item.costTime &&
              _matrixDimensionData.y[yidx].value === item.statHour
          ) {
            cellData.push([item.dateDelayX, item.a1Y * item.nowBl*100/item.statCostAllX]);
          }
        });
        return cellData;
      }

      eachMatrixCell((xval, yval, xidx, yidx) => {
        const id = makeId(xidx, yidx);
        const seriesData = generateSeriesData(filteredData, xidx, yidx);

        option.grid.push({
          id: id,
          coordinateSystem: 'matrix',
          coord: [xval, yval],
          top: 10,
          bottom: 10,
          left: 'center',
          width: '90%',
          containLabel: true
        });

        option.xAxis.push({
          type: 'category',
          id: id,
          gridId: id,
          scale: true,
          axisTick: { show: false },
          axisLabel: { show: false },
          axisLine: { show: false },
          splitLine: { show: false }
        });

        option.yAxis.push({
          id: id,
          gridId: id,
          interval: Number.MAX_SAFE_INTEGER,
          scale: true,

          axisLabel: { showMaxLabel: true, fontSize: 9 },
          axisLine: { show: false },
          axisTick: { show: false }
        });

        option.series.push({
          xAxisId: id,
          yAxisId: id,
          type: 'line',
          symbol: 'none',
          lineStyle: { lineWidth: 1 },
          data: seriesData
        });
      });

      option && myChart.setOption(option);
    },

    filterDataByPage(data, page) {
      const startHour = page * 12; // 每页显示 12 小时
      const endHour = startHour + 11;
      return data.filter(item => {
        const hour = parseInt(item.statHour.split(':')[0], 10);
        return hour >= startHour && hour <= endHour;
      });
    },

    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
        this.renderChart();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++;
        this.renderChart();
      }
    }
  }
};
</script>

<style scoped>
/* 可以在这里添加样式 */
</style>
